import AttributeValues from "./AttributeValues";
import { RecordsToOverride } from "./Utils";

// returns a count of records that will be overridden
export const RecordOverrideCountString = formValues => {
  const count = RecordsToOverride(
    formValues.selectedRecords,
    formValues.attribute,
    formValues.system,
    formValues.attrCode,
    formValues.action,
    formValues.incorrectValue,
    formValues.code
  ).length;

  return count > 0 ? "[" + count + "]" + " record(s) will be overridden." : "";
};

export const AttributeDropDownValues = action => {
  const attributes = [
    { value: "name", displayName: "Name" },
    { value: "identifier", displayName: "Identifier" },
    { value: "address", displayName: "Address" },
    { value: "gender", displayName: "Gender" },
    { value: "birthDate", displayName: "Date of Birth" },
    { value: "phone", displayName: "Phone" },
    { value: "email", displayName: "Email" }
  ].sort((a, b) => a.displayName.localeCompare(b.displayName));

  // birthDate and gender cannot be inactivated or invalidated.
  if (["invalid", "inactive"].includes(action)) {
    return attributes.filter(
      v => v.value !== "birthDate" && v.value !== "gender"
    );
  }
  return attributes;
};

// a list of objects that contain override action values and displayValues
export const ActionDropDownValues = [
  { value: "invalid", displayName: "Invalidate" },
  { value: "inactive", displayName: "Inactivate" },
  { value: "replace", displayName: "Replace" }
].sort((a, b) => a.displayName.localeCompare(b.displayName));

export const IdentifierSystemDropDownValues = mapArray => {
  return [
    ...new Set(
      mapArray.flat().map(v => {
        if (v.has("system")) {
          return v.get("system");
        } else {
          return "[No System]";
        }
      })
    )
  ].sort();
};

export const IdentifierCodeDropDownValues = valueMapList => {
  return [
    ...new Set(
      valueMapList
        .flat()
        .filter(v => !v.has("system") && v.has("code"))
        .map(v => v.get("code"))
    )
  ].sort();
};

export const AttrCodeDropDownValues = valueMapList => {
  return [
    ...new Set(
      valueMapList
        .flat()
        .filter(v => v.has("attrCode"))
        .map(v => v.get("attrCode"))
    )
  ].sort();
};

export const CorrectAndIncorrectDropDownValues = (
  attributeValues,
  attribute,
  system,
  attrCode,
  code
) => {
  var returnList = attributeValues.flat();

  switch (attribute) {
    case "birthDate":
    case "gender":
      return [
        ...new Set(
          returnList
            .filter(v => v.has("displayValue"))
            .map(v => v.get("displayValue"))
        )
      ];
      break;

    case "identifier":
      if (code != "" && system === "[No System]") {
        return [
          ...new Set(
            returnList
              .filter(
                v =>
                  v.has("displayValue") &&
                  v.has("code") &&
                  v.get("code") === code &&
                  !v.has("system")
              )
              .map(v => v.get("displayValue"))
          )
        ];
      } else {
        return [
          ...new Set(
            returnList
              .filter(
                v =>
                  v.has("displayValue") &&
                  v.has("system") &&
                  v.get("system") === system
              )
              .map(v => v.get("displayValue"))
          )
        ];
      }
      break;

    case "address":
    case "name":
    case "phone":
    case "email":
      return [
        ...new Set(
          returnList
            .filter(
              v =>
                v.has("displayValue") &&
                v.has("attrCode") &&
                v.get("attrCode") === attrCode
            )
            .map(v => v.get("displayValue").toUpperCase())
        )
      ];
      break;
  }

  return returnList;
};
